module.exports = __webpack_public_path__ + "static/media/12.7ef6b53c.jpeg";